(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pca-main-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pca-video-card-v2')) {
  customElements.define('pca-video-card-v2', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.opener = this.querySelector('[data-pca-video-open]');
      this.dialog = this.querySelector('[data-pca-video-dialog]');
      this.player = this.querySelector('[data-pca-video-player]');
      this.template = this.querySelector('[data-pca-video-template]');
      this.status = this.querySelector('[data-pca-video-status]');
      if (!this.opener || !this.dialog || !this.template || typeof this.dialog.showModal !== 'function') return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.opener.setAttribute('role', 'button');
      this.opener.setAttribute('aria-haspopup', 'dialog');
      this.opener.addEventListener('click', (event) => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.openVideo();
      }, options);
      this.opener.addEventListener('keydown', (event) => {
        if (event.key === ' ') { event.preventDefault(); this.openVideo(); }
      }, options);
      this.querySelector('[data-pca-video-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        this.releaseVideo();
        if (this.isConnected) this.opener.focus({ preventScroll: true });
      }, options);
      this.dialog.addEventListener('cancel', () => this.releaseVideo(), options);
      this.dialog.addEventListener('keydown', (event) => event.stopPropagation(), options);
      document.addEventListener('shopify:block:select', (event) => {
        if (this.dialog.open && !this.contains(event.target)) this.dialog.close();
      }, options);
    }
    openVideo() {
      if (this.dialog.open) return;
      document.querySelectorAll('pca-video-card-v2').forEach((card) => {
        if (card !== this && card.dialog && card.dialog.open) card.dialog.close();
      });
      this.player.replaceChildren(this.template.content.cloneNode(true));
      this.status.hidden = true;
      this.video = this.player.querySelector('video');
      this.dialog.showModal();
      if (!this.video) return;
      const activeVideo = this.video;
      activeVideo.addEventListener('error', () => {
        if (this.video !== activeVideo) return;
        this.status.textContent = this.status.dataset.error;
        this.status.hidden = false;
      }, { once: true });
      activeVideo.addEventListener('playing', () => { this.status.hidden = true; });
      const pending = activeVideo.play();
      if (pending) pending.catch(() => {
        if (this.video !== activeVideo || !this.dialog.open) return;
        this.status.textContent = activeVideo.error ? this.status.dataset.error : this.status.dataset.fallback;
        this.status.hidden = false;
      });
    }
    releaseVideo() {
      if (this.video) {
        this.video.pause();
        this.video.removeAttribute('src');
        this.video.querySelectorAll('source').forEach((source) => source.removeAttribute('src'));
        this.video.load();
        this.video = null;
      }
      if (this.player) this.player.replaceChildren();
    }
    disconnectedCallback() {
      if (this.events) this.events.abort();
      this.events = null;
      if (this.dialog && this.dialog.open) this.dialog.close();
      this.releaseVideo();
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
